import Vue from 'vue'
import $moment from 'moment'
import Viewer from 'v-viewer'
import Antd from 'ant-design-vue'

import 'viewerjs/dist/viewer.min.css'
import '@/assets/styles/less/index.less'

Vue.use(Antd)
Vue.use(Viewer)

Object.assign(Vue.prototype, {
	$moment,
	/**
	 * 获取北京时间戳
	 * @returns {number}
	 */
	$BJNow() {
		// 将本地时间转为北京东八区时间
		return $moment($moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss.SSS'))
	},
	/**
	 * 友盟站点统计
	 * @param category 表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。
	 * @param action 表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等。
	 * @param label 用于更详细的描述事件，如具体是哪个视频，哪部小说。
	 * @param value 用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格。
	 * @param nodeid 填写事件元素的div元素id。
	 */
	$pushStat(category, action, label, value, nodeid) {
		if (window._czc) {
			window._czc.push(['_trackEvent', category, action, label, value, nodeid])
		}
	}
})

export default ({ app }) => {

}
